var map = {
	"./3.svg": 4190,
	"./35.svg": 9281,
	"./60.svg": 4260,
	"./61.svg": 3915,
	"./62.svg": 8636,
	"./63.svg": 7258,
	"./64.svg": 7056,
	"./65.svg": 32,
	"./66.svg": 4771,
	"./67.svg": 7181,
	"./68.svg": 4617,
	"./69.svg": 3706,
	"./70.svg": 8346,
	"./71.svg": 3452,
	"./72.svg": 1942,
	"./73.svg": 2128,
	"./75.svg": 5029,
	"./76.svg": 5675,
	"./77.svg": 5236,
	"./78.svg": 761,
	"./79.svg": 8065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9183;